"use strict";

import features0 from "../../../../server/public/static/contact/features-0.png"
import features1 from "../../../../server/public/static/contact/features-1.png"
import features2 from "../../../../server/public/static/contact/features-2.png"
import features3 from "../../../../server/public/static/contact/features-3.png"

var React = require("react");
var Global = require('../../global');
var ResponsiveMixin = Global.ResponsiveMixin;

if (require('../../css')) require('./contact.scss')

var ContactForm = require('../../forms/contact-form')

// CONTACT METHOD COMPONENTS
var ContactMethod = props => {
  return (
    <div className="pg-contact-method">
      <div className="pg-contact-title">{props.title1}</div>
      <div className="pg-contact-detail">
        <div className="pg-contact-detail-children">{props.children}</div>
      </div>
    </div>
  );
};

var ContactMethods = React.createClass({
  mixins: [ResponsiveMixin],

  render: function() {
    return (
      <div className="pg-contact-methods">
        <span className="pg-contact-method-wrapper">
          <ContactMethod title1="Call us toll free" title2="">
            <a href="tel:888-871-5777">888-871-5777</a>
          </ContactMethod>
        </span>
        <span className="pg-contact-method-wrapper">
          <ContactMethod title1="Int'l customers" title2="">
            <a href="tel:+1-310-321-5995">+1-310-321-5995</a>
          </ContactMethod>
        </span>
        <span className="pg-contact-method-wrapper">
          <ContactMethod title1="Write to us" title2="">
            <a href="#form" style={{textTransform: "uppercase"}}>Email Us</a>
          </ContactMethod>
        </span>
        <a
          href="https://goo.gl/maps/qPJwb8ArJg12"
          target="_blank"
          className="pg-contact-method-wrapper"
          rel="noreferrer"
        >
          <ContactMethod title1="Visit by appointment" title2="" icon="">
            <span className="pg-contact-address-street">123 Richmond St.</span>
            <br />
            <span className="pg-contact-address-city">
              El Segundo, California
            </span>
          </ContactMethod>
        </a>
     </div>
    );
  }
});

// // MOSAIC
var ContactMosaic = props => {
  var mosaicOutput = props.catList.map((item, i) => {
    return (
      <div className="catListItem" key={i}>
        <div className="catListImage">
          <div className="catListGradient"></div>

          <img
            style={{ objectPosition: item.objectPosition }}
            src={item.image}
            alt={item.name || 'furniture image'}
          />
        </div>
        <div className="catListTitle">{item.title}</div>
      </div>
    );
  });

  return <div className="pg-contact-mosaic">{mosaicOutput}</div>;
};

// LOGOS COMPONENTS
var ContactLogos = props => {
  var logosOutput = props.logoList.map((item, i) => {
    return (
      <div className="logoItem" key={i}>
        <img alt={item.name} src={item.image} />
      </div>
    );
  });
  return <div className="pg-contact-logoStrip">{logosOutput}</div>;
};

var ContactServicesItems = props => {
  var items = props.services.map((item, i) => {
    return (
      <div className="serviceItem" key={i}>
        <div className="serviceTitleWrapper">
          <div className="serviceImage">
            <img src={item.image} width={item.width} height={item.height} alt={item.title || 'services image'}/>
          </div>
          <div className="serviceTitle">{item.title}</div>
        </div>
        <div className="serviceDetails">{item.details}</div>
      </div>
    );
  });

  return <div className="pg-services-items">{items}</div>;
};

// TESTIMONIAL COMPONENTS
class ContactVideoBlock extends React.Component {
  constructor(props) {
    super(props);
    this.state = { videoVisible: false, coverVisible: "block" };
    this.playVideo = this.playVideo.bind(this);
  }

  playVideo(e) {
    e.stopPropagation();
    this.setState({
      coverVisible: "none",
      videoVisible: true,
    });
  }
  render() {
    return (
      <div className="pg-video-wrapper">
        <h3>WHAT OUR CLIENTS SAY ABOUT US</h3>
        <div className="pg-video">
          <div
            onClick={this.playVideo}
            style={{ display: this.state.coverVisible }}
          >
            <picture style={{ cursor: "pointer" }}>
              <source srcSet={`${Payload.webp}/contact/videoThumb.jpg.webp`} type="image/webp"/>
              <source srcSet={`${Payload.static}/contact/videoThumb.jpg`} type="image/jpg"/>
              <img src={`${Payload.static}/contact/videoThumb.jpg`} width="900" height="506" alt='video thumnail' />
            </picture>
          </div>
          {this.state.videoVisible &&
            <div style={{ display: 'block'}}>
              <iframe
                src="https://player.vimeo.com/video/123676395?color=1d9fdd&title=0&byline=0&portrait=0"
                frameBorder="0"
                allowFullScreen
                title="Vimeo player"
              ></iframe>
            </div>}
        </div>
      </div>
    );
  }
}

// OVERALL LAYOUT AND OUTPUT
var Contact = React.createClass({
  mixins: [ResponsiveMixin],

  render: function() {
    return (
      <div id="pages">
        <div className="pg-contact">
          <div className="pg-contact-hero">
            <div className="pg-contact-hero-text">
              <h2>Beautiful Workspaces - Made Simple</h2>
              <div>
                <p>
                  StrongProject is a cutting-edge business furniture resource
                  for companies looking to purchase Modern Office Furniture for
                  their commercial office spaces. We are a “One Stop Shop” for
                  Furnishing Complete Office Spaces!
                </p>
                <p>
                  StrongProject’s Los Angeles, CA office is the planning hub for
                  all our commercial office furniture projects Nationwide and we
                  provide White Glove Nationwide Installation Services. We have
                  planned and shipped furniture projects as far away as
                  Australia & Nigeria!
                </p>
                <p>
                  Streamline the process with StrongProject and realize Bulk
                  Discounts with a StrongProject Modern Office Furniture
                  Package.
                </p>
              </div>
            </div>
            <div className="pg-contact-hero-image">
              <picture>
                <source srcSet={`${Payload.webp}/contact/Top-of-Page-Hero-Shot-lg.jpg.webp 1254w, ${Payload.webp}/contact/Top-of-Page-Hero-Shot.jpg.webp 690w`} type="image/webp"/>
                <source srcSet={`${Payload.static}/contact/Top-of-Page-Hero-Shot-lg.jpg 1254w, ${Payload.static}/contact/Top-of-Page-Hero-Shot.jpg 690w`} type="image/jpg"/>
                <img src={`${Payload.static}/contact/Top-of-Page-Hero-Shot-lg.jpg`} srcSet={`${Payload.static}/contact/Top-of-Page-Hero-Shot-lg.jpg 1254w, ${Payload.static}/contact/Top-of-Page-Hero-Shot.jpg 690w`} sizes="100vw" width='690' height='388' alt='contact hero image'/>
              </picture>
            </div>
          </div>
          <ContactMethods />
          <div className="pg-contact-hero">
            <div className="pg-contact-hero-image">
              <picture>
                <source srcSet={`${Payload.webp}/contact/Secondary-Image.jpg.webp`} type="image/webp"/>
                <source srcSet={`${Payload.static}/contact/Secondary-Image.jpg`} type="image/jpg"/>
                <img src={`${Payload.static}/contact/Secondary-Image.jpg`} alt='contact secondary image' width="690" height="488" />
              </picture>
            </div>
            <div className="pg-contact-hero-text">
              <h2>Our modern office furniture showroom</h2>
              <div>
                <p>
                  Our Showroom, located in Los Angeles, CA, features a
                  collection of modern office furniture designs that you will
                  not find anywhere else. If you are located outside of Southern
                  California and would like to fly in for a “planning day” or to
                  “kick the tires”, we are conveniently located just minutes
                  from LAX and we will have a driver pick you up from the
                  airport and drive you back.
                </p>
                <p>
                  Come in and visit us! Whether you’re looking for our stylish,
                  Italian office furniture or our unique, modern workstations,
                  our product offerings reflect the most innovative designs in
                  contemporary business furniture, and you can see them in
                  person. Get a feel for what these new styles are really like,
                  see the commercial-grade quality and get a vision for how your
                  new office will appear.
                </p>
                <p>
                  Make an appointment to come in and visit our Los Angeles
                  showroom!
                </p>
              </div>
            </div>
          </div>
          <div className="pg-contact-form-and-mosaic-wrapper">
            <ContactForm source="contact" submit="Get started"></ContactForm>
            <div className="contact-mosaic">
              {[
                {header: 'Private Office Furniture', path: 'contact/1-Private-Office-Furniture.jpg'},
                {header: 'Open Office Workstations', path: 'contact/2-Open-Office-Workstations.jpg'},
                {header: 'Conference Rooms', path: 'contact/Conference-Rooms.jpg'},
                {header: 'Reception Desks', path: 'contact/4-Reception-Desks.jpg'},
                {header: 'Collaborative Furniture', path: 'contact/5-Collaborative-Furniture.jpg'},
                {header: 'Acoustic Furniture', path: 'contact/Acoustic-Furniture.png'},
                {header: 'Office Chairs', path: 'contact/7-Office-Chairs-1.jpg'},
                {header: 'Sit-Stand Desks', path: 'contact/8-Sit-Stand-Desks.jpg'},
                {header: 'Lockers and Storage', path: 'contact/9-Lockers-Storage-1000.jpg'}
              ].map((item, i) =>
                <div className="tile" key={i}>
                  <picture>
                    <source srcSet={`${Payload.webp}/${item.path}.webp`} type="image/webp"/>
                    <source srcSet={`${Payload.static}/${item.path}`} type="image/jpg"/>
                    <img src={`${Payload.static}/${item.path}`} width='228' height='219' alt={item.name || 'furniture image'} />
                  </picture>
                  <h4>{item.header}</h4>
                </div>
              )}
            </div>
          </div>
          <div className="pg-contact-logos">
            <h3 className="title">Our clients include</h3>
            <div className="pg-contact-logoStrip">
                {[
                    { name: "Variety", image: "contact/logo-variety.png" },
                    { name: "The Disney Company", image: "contact/logo-disney.png" },
                    { name: "Tesla Motors", image: "contact/logo-tesla.png" },
                    { name: "Ocean Spray", image: "contact/logo-ocean-spray.png" },
                    { name: "Direct TV", image: "contact/logo-direct-tv.png" },
                    { name: "Hyatt Regency", image: "contact/logo-hyatt.png" },
                    { name: "Porsche", image: "contact/logo-porsche.png" },
                    { name: "Toyota Motors", image: "contact/logo-toyota.png" }
                 ].map((item, i) =>
                     <div className="tile" key={i}>
                        <picture>
                          <source srcSet={`${Payload.webp}/${item.image}.webp`} type="image/webp"/>
                          <source srcSet={`${Payload.static}/${item.image}`} type="image/jpg"/>
                          <img key={`${Payload.static}/${item.image}`} src={`${Payload.static}/${item.image}`} alt={item.name} width='130' height='130' />
                        </picture>
                      </div>
                 )}
            </div>
          </div>
          <div className="pg-services-wrapper">
            <h3 className="title">What you get when you work with us</h3>
            <div className="pg-servicesItems">
              <ContactServicesItems
                services={[
                  {
                    title: "PROJECT-BASED QUOTING",
                    image: features0,
                    width: "50",
                    height: "38",
                    details:
                      "Ask us for a free Preliminary Budget Estimate to furnish your whole space and realize Bulk Discounts through project based pricing. Monthly financing on your Furniture Package is also available!"
                  },
                  {
                    title: "DEDICATED CONSULTING",
                    image: features1,
                    width: "50",
                    height: "30",
                    details:
                      "All our customers are assigned a dedicated Project Consultant to provide personalized service throughout the planning process at no charge. They will coordinate your needs assessment, workspace furniture plan, design planning, budget development, purchasing and installation coordination."
                  },
                  {
                    title: "CUSTOM TOUCHES",
                    image: features2,
                    width: "50",
                    height: "32",
                    details:
                      "The Modern Furniture Designs that you see on our website come in numerous finishes, sizes and configurations. Your Project Consultant will work with you to incorporate the proper sizes within your furniture plan as well as help you navigate and select the best design options that work optimally with your space, design vision, lead time requirement and budget."
                  },
                  {
                    title: "DELIVERY & INSTALLATION",
                    image: features3,
                    width: "50",
                    height: "30",
                    details:
                      "Instead of trying to coordinate multiple furniture deliveries & installations through numerous vendors, we can be your single source for planning and purchasing your modern workplace furnishings all the way through coordinating a single delivery and installation."
                  }
                ]}
              />
            </div>
          </div>
          <ContactVideoBlock />
          <div className="pg-testimonials">
              {[
                {
                  title: "Glenn Kalison",
                  subtitle: "CEO RELATIVITY EDUCATION",
                  image: "contact/test-glenn.jpg",
                  width: '80',
                  height: '80' ,
                  details: (
                    <p>
                      "In the end, sleek and efficient designs created greater
                      functionality conducive to a cutting-edge educational
                      environment.{" "}
                      <b>
                        The sleek, modern, value furniture solutions that
                        StrongProject recommended
                      </b>{" "}
                      for Relativity School resulted in an aesthetic that was far
                      richer than the price tag itself—
                      <b>
                        all of which added to the brand and helped tell the
                        school’s unique story.""
                      </b>
                    </p>
                  )
                },
                {
                  title: "Dierdre Bronchick",
                  subtitle: "INTERIOR DESIGNER, COVE STREET CAPITAL",
                  image: "contact/test-dierdre.jpg",
                  width: '80',
                  height: '80' ,
                  details: (
                    <p>
                      “<b>StrongProject had everything that we wanted.</b>{" "}
                      Investment companies are now thinking outside of the box and
                      we didn’t want to do the standard banker’s office.{" "}
                      <b>
                        I came to them with a list of requirements from the
                        client, and StrongProject was able to source it, and stay
                        on budget.
                      </b>
                      ”
                    </p>
                  )
                },
                {
                  title: "Yvonne Tung",
                  subtitle: "EXECUTIVE VICE PRESIDENT, TRANSGLOBAL",
                  image: "contact/test-yvonne.jpg",
                  width: '80',
                  height: '80' ,
                  details: (
                    <p>
                      “I’ve worked with a lot of different vendors in different
                      cities. <b>StrongProject is very different</b>, because the
                      first thing they do is not recommend furniture to us but to
                      understand what kind of business we’re in and what kind of
                      office we’re going to have...
                      <b>
                        when I work with StrongProject, I feel the professionalism
                        they provide, I feel the passion from their staff, and I
                        feel their products are incomparable
                      </b>
                      . I am so happy about this experience.”
                    </p>
                  )
                },
                {
                  title: "Grant Kirkwood",
                  subtitle: "CEO UNITAS GLOBAL",
                  image: "contact/test-grant.jpg",
                  width: '80',
                  height: '80' ,
                  details: (
                    <p>
                      If the overall team dynamics and goals aren’t considered
                      during the planning phase, it can go horribly wrong.
                      <b>
                        StrongProject engaged with the people on our team
                        throughout, making sure we accomplished our goals.
                        StrongProject has been with us throughout the entire
                        process.
                      </b>
                    </p>
                  )
                }
              ].map((item, i) =>
                  <div className="testimonialItem" key={i}>
                    <div className="testimonialTitleWrapper">
                      <div className="testimonialImage">
                        <picture>
                          <scource srcSet={`${Payload.webp}/${item.image}.webp`} type="image/webp" />
                          <scource srcSet={`${Payload.static}/${item.image}`} type="image/jpg" />
                          <img src={`${Payload.static}/${item.image}`} width={item.width} height={item.height} alt={item.name || 'furniture image'}/>
                        </picture>
                      </div>
                      <div className="testimonialTitle">{item.title}</div>
                      <div className="testimonialSubTitle">{item.subtitle}</div>
                    </div>
                    <div className="testimonialDetails">{item.details}</div>
                  </div>
              )}
          </div>
        </div>
      </div>
    );
  }
});

module.exports = Contact



// WEBPACK FOOTER //
// ./src/pages/content/contact.jsx